import React, { useState, useEffect } from "react";
import { IonButton, IonSpinner } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useGetSmsCode } from "../../../../providers/Auth";

interface ResendOtpSmsProps {
  phone: string;
  onSendSuccess?: (data: any) => void;
  onSendError?: (error: any) => void;
  initialTimer?: number;
  className?: string;
}

export default function ResendOtpSms({
  phone,
  onSendSuccess,
  onSendError,
  initialTimer = 15,
  className = "text-black flex",
}: ResendOtpSmsProps) {
  const { t } = useTranslation();
  const { mutate: getSmsCodeQuery, isLoading: isSmsQueryLoading } = useGetSmsCode();
  const [timer, setTimer] = useState(initialTimer);

  const isTimerActive = timer > 0;

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isTimerActive) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isTimerActive]);

  const handleResendCode = () => {
    getSmsCodeQuery(
      { phone },
      {
        onSuccess: (data) => {
          setTimer(initialTimer);
          onSendSuccess?.(data);
        },
        onError: (error) => {
          console.error("Failed to send SMS:", error);
          onSendError?.(error);
        },
      },
    );
  };

  const isDisabled = isTimerActive || isSmsQueryLoading;

  return (
    <IonButton fill="clear" className={className} onClick={handleResendCode} disabled={isDisabled}>
      <span>
        {isTimerActive
          ? `${t("Send code by SMS")} ( ${timer} )`
          : isSmsQueryLoading
            ? t("Sending...")
            : t("Send code by SMS")}
      </span>
      {isSmsQueryLoading && <IonSpinner className="ml-2 size-5 text-red-600" />}
    </IonButton>
  );
}
